import { IIconBase } from '..'

const AddIcon = ({ color = '#292D32', height = 14, width = 14 }: IIconBase) => {
  return (
    <svg width={width} height={height} viewBox='0 0 14 14' fill='none'>
      <g id='vuesax/linear/add'>
        <g id='add'>
          <path
            id='Vector'
            d='M3.5 7H10.5'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M7 10.5V3.5'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default AddIcon
